<template>
  <div>
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'Blank'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Blank.vue